<template>
    <b-form-row>
        <b-col cols="6" sm="5" md="2">
            <div class="coverpage-back-annual-plan">
                <b-button :to="{name: 'annualPlan',
                                params: {applicationId: applicationId}
                          }"
                          class="coverpage-back-title"
                >
                    <fa-icon :icon="['fal','chevron-circle-left']" />
                    Back to Annual Plan
                </b-button>
            </div>
            <br>
            <b-nav pills vertical class="shadow">
                <b-nav-item
                    v-for="tab in modulesForCoverPageTabList"
                    :key="tab.name"
                    class="tab-outline"
                    :active-class="'active tab-outline'"
                    :exact-active-class="'active tab-outline'"
                    exact
                    :to="{
                        ...tab.route,
                        params: {formDisabled, applicationId}
                    }"
                >
                    <fa-icon
                        v-if="tab.statusIcon"
                        :icon="tab.statusIcon.icon"
                        :class="tab.statusIcon.classes"
                    />
                    {{ tab.description }}
                </b-nav-item>
            </b-nav>
        </b-col>
        <b-col cols="6" sm="7" md="10">
            <transition name="fade" mode="out-in">
                <fieldset>
                    <router-view :key="$route.fullPath" :form-disabled="formDisabled" />
                </fieldset>
            </transition>
        </b-col>
    </b-form-row>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
    name: 'CoverPage',

    props: {
        applicationId: { type: Number, default: null },
    },

    data() {
        return {
            isSaving: false,
            activeTab: null,
            tabIndex: 0
        };
    },

    computed: {
        ...mapGetters({
            perkinsCoverPageModules: 'ref/coverpage/modules',
            currentAy: 'ref/global/currentAy',
            // isApplicationEditable: 'application/isApplicationEditable',
            isCoverPageEditable: 'coverpage/isEditable',
        }),

        ...mapState('coverpage', {
            coverPageData: state => state.data
        }),

        ...mapState('application', {
            applicationData: state => state.applicationData,
            academicYear: state => state.applicationData.academic_year,
        }),

        modulesForCoverPageTabList() {
            return this.perkinsCoverPageModules.map(tab => {
                return {
                    ...tab,
                    hasUnsavedChanges: null,
                    hasBeenActedOn: null,
                    statusIcon: false
                };
            });
        },

        formDisabled() {
            return !this.isCoverPageEditable;
        }
    },

    async mounted() {
        await this.fetchApplication(this.applicationId);
        if (this.applicationData === null ||
            this.applicationData.applicationId !== this.applicationId
        ) {
            await this.fetchLocalApplicationRef({ academicYear: this.currentAy });
            await this.fetchRefPerkinsIndicators({ academicYear: this.academicYear });
            const application = await this.fetchApplication(this.applicationId);
            await this.fetchLocalApplicationModules(
                { academicYear: this.academicYear, applicantId: application.applicant_id }
            );
        }

        await this.fetchCoverPage(this.applicationId);
    },

    methods: {
        ...mapActions({
            fetchApplication: 'application/fetchApplication',
            fetchLocalApplicationRef: 'ref/localApplication/fetch',
            fetchRefPerkinsIndicators: 'ref/perkinsIndicators/fetch',
            fetchLocalApplication: 'localApplication/fetch',
            fetchLocalApplicationModules: 'localApplication/module/fetch',
            fetchCoverPage: 'coverpage/fetch'
        }),
    },
};
</script>

<style lang="scss">
.nav-item-status-icon {
    margin-top: -0.25rem;
    padding-left: 0.25rem;
    font-size: 1.25em;
    float: right;
}

.coverpage-back-annual-plan .coverpage-back-title{
  font-size: medium;
  text-decoration: none;
  color: white;
  font-weight: bold;
  background: #380064;
}
</style>
